export default "__VITE_ASSET__DUcv_k96__"